
















import { CodebookModel, CodebookTypeEnum } from '@/libs/Api';
import { codebooksStore } from '@/libs/codebooks/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import {Component, Prop, VModel, Vue, Watch} from 'vue-property-decorator';

@Component({ })
export default class CodebookSelect extends Vue {

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() type!: string;
    @Prop() placeholder!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: any[];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) useDefaultValue!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: null }) except!: string[] | null;

	@Watch("innerValue")
	innerValueChanged (v: string, p: string) {
		this.$emit("change", v, p);
	}

    get items(): CodebookModel[] {
        const type = this.type;
        let items = codebooksStore.useGetter(CrudGetter.Data)?.filter((e: CodebookModel) => {
            return e.type == CodebookTypeEnum[type as keyof typeof CodebookTypeEnum];
        }).sort((a: CodebookModel, b: CodebookModel) => { return a.position! - b.position!; }) as Array<CodebookModel>;
        if (this.except) {
            items = items.where(x => !this.except!.contains(x.id!)).toArray();
        }
        items.forEach((e: CodebookModel) => {
            e.name = this.$i18n.t("codebooks.".concat(e.nameIdentifier!)).toString();
        });
        if (this.useDefaultValue && this.innerValue == null && items.find((x: CodebookModel) => x.defaultValue)) {
            this.$emit("input", items.find((x: CodebookModel) => x.defaultValue == true)?.id);
        }
        return items;
    }

}
